var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZirochka(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9601 14.2328C28.6319 14.0062 29.2631 13.725 29.9299 13.5001C30.3741 13.3503 30.717 13.188 31.1167 12.9671C31.2947 12.8686 31.4675 12.7083 31.6604 12.6432",
    stroke: "#FDBB11",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83599 25.2095C6.05593 25.1641 6.23149 24.9652 6.43731 24.8751C6.73174 24.7463 6.92958 24.7076 7.17393 24.5008C7.32286 24.3747 7.5071 24.1988 7.69437 24.1363C7.95929 24.048 8.21748 23.8133 8.47142 23.6863C8.66816 23.5879 8.75207 23.4304 8.90581 23.3151",
    stroke: "#FDBB11",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38057 13.7242C9.16599 13.5626 8.94929 13.4686 8.70099 13.3591C8.23188 13.1524 7.7223 12.7799 7.21711 12.6728C7.02084 12.6312 6.77513 12.4853 6.58924 12.4706C6.50838 12.4642 6.36575 12.4752 6.32178 12.4114",
    stroke: "#FDBB11",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.379 25.4021C28.2104 25.202 28.0269 25.0678 27.817 24.9122C27.4204 24.6184 27.0177 24.1542 26.5687 23.9511C26.3943 23.8722 26.1937 23.6814 26.0238 23.631C25.9499 23.609 25.8153 23.5921 25.7866 23.521",
    stroke: "#FDBB11",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6083 28.9091C18.684 29.0246 18.6836 29.1622 18.7025 29.2966C18.7325 29.51 18.8334 29.6865 18.8671 29.9032C18.9427 30.3892 19.0753 30.8554 19.0627 31.3554C19.0551 31.6533 19.1253 31.942 19.1539 32.2387C19.1812 32.5205 19.1289 32.7813 19.1134 33.0613C19.1024 33.259 19.1251 33.4419 19.0995 33.6358C19.0888 33.7172 19.1449 33.8259 19.0697 33.8778",
    stroke: "#FDBB11",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7874 3.58377C17.8671 3.69656 17.8717 3.8341 17.8953 3.96767C17.9329 4.17986 18.0401 4.35264 18.0815 4.56801C18.1743 5.051 18.3235 5.51225 18.3287 6.0123C18.3317 6.31035 18.4121 6.5963 18.4514 6.89183C18.4886 7.17245 18.4456 7.43499 18.4401 7.71539C18.4362 7.91328 18.4654 8.09534 18.4468 8.28997C18.4389 8.37176 18.4989 8.47839 18.4256 8.53288",
    stroke: "#FDBB11",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2074 17.3964C22.4878 18.0948 22.3514 18.8313 21.7045 19.6512C21.0359 20.4987 19.9243 21.2674 18.7127 21.7538C17.7687 22.1328 16.9105 22.0228 16.1637 21.5986C15.3825 21.1548 14.6763 20.3316 14.242 19.2499C13.9273 18.466 14.0513 17.5853 14.627 16.6891C15.2126 15.7774 16.2061 14.9692 17.332 14.5172C18.196 14.1704 19.1402 14.2967 20.0547 14.8433C20.9865 15.4004 21.7857 16.3459 22.2074 17.3964Z",
    stroke: "#FDBB11",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZirochka);
export default __webpack_public_path__ + "static/media/zirochka.ac41415bc11357543ec84b5c51b2394f.svg";
export { ForwardRef as ReactComponent };